import axios from 'axios';
import Vue from 'vue'

// 创建一个 axios 实例
const instance = axios.create({
    baseURL: '', // 设置基础 URL
    timeout: 2000000, // 设置超时时间
    headers: {
        'Content-Type': 'application/json',
        // 其他全局默认头信息
    },
});

// 请求拦截器
instance.interceptors.request.use(
    config => {
        var time = localStorage.getItem('loginTime')
        if(time) {
            localStorage.setItem('loginTime', new Date().getTime())
        }
        if(config.data) {
            for(var key in config.data) {
                if(typeof (config.data[key]) === "number") {
                    config.data[key] = config.data[key]+''
                }
            }
        }
        return config;
    },
    error => {
        // 对请求错误做些什么
        return Promise.reject(error);
    }
);

// 响应拦截器
instance.interceptors.response.use(
    response => {
        let data = response.data
        if(data.success === 'false' || data.indexOf('"success": "false"')!==-1) {
            Vue.prototype.$message.error({
                message: data.msg || data,
                duration: 3000,
                showClose: true
            })
        }else {
            if(response.data.indexOf('！')!==-1) {
                Vue.prototype.$message.error({
                    message: response.data,
                    duration: 3000,
                    showClose: true
                })
            }else
                return response.data;
        }
        // 对响应数据做点什么
    },
    error => {
        // 对响应错误做点什么
        if (error.response) {
            let msg = ''
            if(!error.response.data.errors) msg= error.response.data
            else msg = error.response.data.errors.askStr[0]
            // let status = error.response.status
            Vue.prototype.$message.error({
                message: msg,
                duration: 3000,
                showClose: true
            })
        }
        return Promise.reject(error);
    }
);

// 封装常用的请求方法
const request = {
    get: (url, params = {}) => instance.get(url, { params }),
    post: (url, data = {}) => instance.post(url, data),
    put: (url, data = {}) => instance.put(url, data),
    delete: (url, data = {}) => instance.delete(url, { data }),
};

export default request;
